import { render, staticRenderFns } from "./TransferInventory.vue?vue&type=template&id=9ff007f2&scoped=true"
import script from "./TransferInventory.vue?vue&type=script&lang=js"
export * from "./TransferInventory.vue?vue&type=script&lang=js"
import style0 from "./TransferInventory.vue?vue&type=style&index=0&id=9ff007f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff007f2",
  null
  
)

export default component.exports